module.exports = __webpack_public_path__ + "static/media/product details.56081335.png";